export default {
  data: function () {
    return {
      state: {
        loadingLayer: {
          show: false,
          message: ''
        }
      }
    }
  },
  methods: {
    showLayer(message) {
      this.state.loadingLayer = {
        show: true,
        message
      }
    },
    hidingLayer() {
      this.state.loadingLayer = {
        show: false,
        message: '...'
      }
    },
  }
}